/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ProfileShowcase_tradeFirm$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type NextStatusComparison_tradeFirm$ref: FragmentReference;
export type NextStatusComparison_tradeFirm = {|
  +rewards: ?{|
    +currentProgram: ?{|
      +programInfo: ?{|
        +code: ?string,
        +iconUri: ?string,
        +shortCopy: ?string,
      |}
    |},
    +nextProgram: ?{|
      +programInfo: ?{|
        +code: ?string,
        +shortCopy: ?string,
      |}
    |},
    +rewardsPageComparisonHeader: ?{|
      +currentProgram: ?{|
        +children: ?$ReadOnlyArray<?{|
          +longCopy: ?string
        |}>
      |},
      +nextProgram: ?{|
        +children: ?$ReadOnlyArray<?{|
          +longCopy: ?string
        |}>
      |},
    |},
  |},
  +$fragmentRefs: ProfileShowcase_tradeFirm$ref,
  +$refType: NextStatusComparison_tradeFirm$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shortCopy",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "children",
    "storageKey": null,
    "args": null,
    "concreteType": "LoyaltyProgram",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "longCopy",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Fragment",
  "name": "NextStatusComparison_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ProfileShowcase_tradeFirm",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "rewards",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmRewards",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "currentProgram",
          "storageKey": null,
          "args": null,
          "concreteType": "ParentProgram",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "programInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "LoyaltyProgram",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "iconUri",
                  "args": null,
                  "storageKey": null
                },
                (v1/*: any*/)
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "nextProgram",
          "storageKey": null,
          "args": null,
          "concreteType": "ParentProgram",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "programInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "LoyaltyProgram",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "rewardsPageComparisonHeader",
          "storageKey": null,
          "args": null,
          "concreteType": "RewardsPageComparisonHeaderType",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "currentProgram",
              "storageKey": null,
              "args": null,
              "concreteType": "FilteredChildProgramList",
              "plural": false,
              "selections": (v2/*: any*/)
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "nextProgram",
              "storageKey": null,
              "args": null,
              "concreteType": "FilteredChildProgramList",
              "plural": false,
              "selections": (v2/*: any*/)
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '5d8a985c596a6650ee0b6f8cda6e32a8';
module.exports = node;
